export class DecisionPointShare {
    displaySocialShareTools() {
        let toolbarLayout = $(".article-wrapper .title-area .toolbar");

        if (toolbarLayout && toolbarLayout.length) {
            toolbarLayout.addClass('dp-article-toolbar');
            const authType = this.checkAuthUser();
            if (authType === "logged-in") {
                $("#bodypadding").addClass(authType);
                $(".email-modal").addClass('dp-email-modal-window');
            }
            else if (authType === "logged-out") {
                $("#bodypadding").addClass("logged-in");
            }
            else {
                toolbarLayout.addClass('dp-article-no-toolbar');
            }
        }
    }

    checkAuthUser() {
        const authCode = s_auth_channel_id !== 'undefined' ? s_auth_channel_id : "";
        if (typeof s_registered_user_id !== 'undefined' && authCode && (authCode === "103-2" || authCode === "104-2" || authCode === "105-2" || authCode === "107-2" || authCode === "108-2")) {
            return "logged-in";
        }
        else if (typeof s_registered_user_id !== 'undefined' && authCode && (authCode === "101-1" || authCode === "102-1")) {
            return "logged-out";
        }
        else {
            return "anonymous";
        }
    }

}